"use client"

import { Hospital } from "lucide-react"

export function AnimatedLogo() {
  return (
    <div className="flex items-center group cursor-pointer">
      <div className="relative mr-3">
        {/* Main hospital icon */}
        <Hospital className="h-8 w-8 text-blue-600 transition-all duration-300 group-hover:scale-110" />

        {/* Animated pulse dot */}
        <div className="absolute -top-1 -right-1 w-3 h-3">
          <div className="w-3 h-3 bg-emerald-400 rounded-full animate-pulse"></div>
          <div className="absolute inset-0 w-3 h-3 bg-emerald-400 rounded-full animate-ping opacity-30"></div>
        </div>

        {/* Subtle glow effect on hover */}
        <div className="absolute inset-0 w-8 h-8 bg-blue-600/20 rounded-lg blur-md opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
      </div>

      <div className="flex flex-col">
        <span className="font-bold text-xl text-gray-900 group-hover:text-blue-600 transition-colors duration-300">
          Clinic365
        </span>
        <span className="text-xs text-gray-500 font-medium tracking-wider uppercase opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-y-1 group-hover:translate-y-0">
          AI-Powered
        </span>
      </div>
    </div>
  )
}
